import firstPost from './posts/first-post.md';
import websocketsBenchmark from './posts/websockets-benchmark.md';
import tilTcpReuseaddr from './posts/til-tcp-reuseaddr.md';
import loraFineTuning from './posts/lora-fine-tuning.md';
import lsmTreeKvStore from './posts/lsm-tree-kv-store.md';

export const posts = [
  {
    slug: 'websockets-benchmark',
    title: 'Benchmarking 1,000,000 Concurrent WebSockets: Go vs Rust vs Node.js',
    date: '2026-08-28',
    type: 'benchmark',
    bentoSize: 'hero', // 2-col span
    badge: '🔥 BENCHMARK REPORT',
    badgeColor: 'amber',
    readTime: '12 min read',
    excerpt: 'Evaluating memory footprint per connection, epoll event loops, kernel socket buffer tuning, and garbage collection disruptions under extreme concurrent loads.',
    tags: ['Go', 'Rust', 'Linux', 'Concurrency', 'Networking'],
    category: 'Benchmarks',
    content: websocketsBenchmark
  },
  {
    slug: 'til-tcp-reuseaddr',
    title: 'TIL: TCP TIME_WAIT, SO_REUSEADDR, and Port Exhaustion',
    date: '2026-08-20',
    type: 'til',
    bentoSize: 'mini', // 1-col mini
    badge: '💡 TIL SNIPPET',
    badgeColor: 'blue',
    readTime: '3 min read',
    excerpt: 'Why ephemeral port exhaustion occurs under high connection churn and how socket reuse flags and HTTP transport pools mitigate it.',
    tags: ['Networking', 'Linux', 'Go'],
    category: 'TIL Snippets',
    content: tilTcpReuseaddr
  },
  {
    slug: 'lora-fine-tuning',
    title: 'Fine-Tuning Small Language Models with LoRA and QLoRA',
    date: '2026-08-14',
    type: 'deepdive',
    bentoSize: 'medium', // 1-col
    badge: '🧠 NEURAL ARCHITECTURE',
    badgeColor: 'purple',
    readTime: '8 min read',
    excerpt: 'Low-rank matrix decomposition for efficient local GPU training on 7B & 8B parameter models with zero latency inference penalty.',
    tags: ['PyTorch', 'Transformers', 'PEFT', 'Python'],
    category: 'Deep Dives',
    content: loraFineTuning
  },
  {
    slug: 'lsm-tree-kv-store',
    title: 'Building a Distributed Key-Value Store with LSM-Trees in Rust',
    date: '2026-07-30',
    type: 'opensource',
    bentoSize: 'wide', // 2-col span
    badge: '📦 OPEN SOURCE EXPERIMENT',
    badgeColor: 'emerald',
    readTime: '10 min read',
    excerpt: 'MemTable flush pipelines, Write-Ahead Logs (WAL), Bloom filter indexing, and SSTable background compaction strategies.',
    tags: ['Rust', 'Storage Engines', 'Distributed Systems'],
    category: 'Open Source',
    content: lsmTreeKvStore
  },
  {
    slug: 'first-post',
    title: 'Engineering Reflections: Building Resilient Distributed Systems',
    date: '2026-06-15',
    type: 'deepdive',
    bentoSize: 'medium',
    badge: '⚡ ARCHITECTURE NOTES',
    badgeColor: 'blue',
    readTime: '5 min read',
    excerpt: 'Core paradigms in distributed systems: failure domains, idempotent RPC handlers, and designing for eventual consistency.',
    tags: ['Distributed Systems', 'System Design', 'Architecture'],
    category: 'Deep Dives',
    content: firstPost
  }
];
